import React from 'react';
import { Button } from '../Button/Button';

import arrow from '../../images/arrow-curly.svg';
import asana from '../../images/asana.svg';
import slackCard from '../../images/slack.svg';
import note from '../../images/note.svg';
import appMock from '../../images/app-mock.svg';
import boringCompany from '../../images/boring-company.svg';
import intercom from '../../images/intercom.svg';
import linkedin from '../../images/linkedin.svg';
import matrixPartners from '../../images/matrix-partners.svg';
import swiggy from '../../images/swiggy.svg';
import yCombinator from '../../images/y-combinator.svg';
import scribble from '../../images/scribble.svg';
import './Hero.scss';

const Hero = () => (
  <>
    <div className="hero container">
      <img className="card card-1" src={slackCard} alt="slack" />
      <img className="card card-2" src={note} alt="note" />
      <h1 className="heading">
        Be more
        <span className="text-gradient"> effective </span>
        <br />
        and less busy
      </h1>
      <p className="sub-heading">
        Aerotime helps you work in flow state by streamlining your meetings and
        making it easier to prioritize tasks.
      </p>
      <div className="wrap">
        <Button size="xl" text="Get started" type="primary" />
        <img className="arrow" src={arrow} alt="" />
      </div>
      <img className="card card-3" src={asana} alt="" />
    </div>
    <div className="hero-section">
      <img className="app-mock container" src={appMock} alt="app-mock" />
      <div className="brands container">
        <h1>Trusted by dynamic companies</h1>
        <div className="brand-images">
          <img
            className="brand-image"
            src={boringCompany}
            alt="boring-company"
          />
          <img className="brand-image" src={linkedin} alt="linkedin" />
          <img className="brand-image" src={swiggy} alt="swiggy" />
          <img className="brand-image" src={yCombinator} alt="y-combinator" />
          <img
            className="brand-image"
            src={matrixPartners}
            alt="matrix-partners"
          />
          <img className="brand-image" src={intercom} alt="intercom" />
        </div>
        <div className="wrap-info">
          <div className="empty"></div>
          <div className="fill">
            <div className="border"></div>
            <div className="backed-companies">Also backed by</div>
          </div>
        </div>
        <img className="scribble" src={scribble} alt="scribble" />
      </div>
    </div>
  </>
);

export default Hero;
